// extracted by mini-css-extract-plugin
export default {"brand":"Logo_brand__A4MRn","logo":"Logo_logo__bXRYk","brandName":"Logo_brandName__N3HxO"};